import { Component, Input, OnInit } from '@angular/core';
import {
  WagtailButtonRendererInterface,
  WagtailFullbleed2ColRenderInterface,
  WagtailPageContentElementInterface
} from "@gea-waldviertler-website/gea-models";
import { v4 as uuidv4 } from "uuid";
import { WagtailUrlPipe } from "../../../pipes/wagtailUrl.pipe";
import { WagtailButtonClassPipe } from "../../../pipes/wagtailButtonClass.pipe";

@Component({
    selector: 'wagtail-page-element-shop-fullbleed2col',
    templateUrl: './shop-fullbleed2col.component.html',
    styleUrls: ['./shop-fullbleed2col.component.scss'],
    standalone: false
})
export class ShopFullbleed2ColComponent implements OnInit {

  @Input() definition?: WagtailPageContentElementInterface<WagtailFullbleed2ColRenderInterface>
  content?: WagtailFullbleed2ColRenderInterface
  buttonDefinition?: WagtailPageContentElementInterface<WagtailButtonRendererInterface>

  ngOnInit(): void {
    if (this.definition) {
      if (this.definition.value.button_url) {
        const urlpipe = new WagtailUrlPipe()
        const classpipe = new WagtailButtonClassPipe()
        this.buttonDefinition = {
          type: "button",
          value: {
            label: this.definition.value.button_text,
            url: urlpipe.transform(this.definition.value.button_url),
            new_window: false,
            cssClass: classpipe.transform(this.definition.value.button_type),
          },
          id: uuidv4()
        }
      }

      this.content = this.definition.value
    }
  }
  
}
